import React, { useEffect, useRef, useState } from 'react';
import { bevestigCode, gebruikHerstelcode, gekoppeldeApp } from '../../services/tweestapsService';
import { schoonCode, tweestapsFoutMelding } from '../../utils/tweestaps';
import './Tweestaps.css';

/**
 * Code uit de authenticator-app invullen na het wachtwoord. Met "Telefoon kwijt?"
 * kan de gebruiker een herstelcode gebruiken; dat koppelt de app los (onHersteld).
 */
function TweestapsCode({ onKlaar, onHersteld }) {
  const [modus, setModus] = useState('code'); // code | herstel
  const [code, setCode] = useState('');
  const [herstelcode, setHerstelcode] = useState('');
  const [bezig, setBezig] = useState(false);
  const [fout, setFout] = useState('');
  const invoer = useRef(null);

  useEffect(() => { invoer.current?.focus(); }, [modus]);

  const verstuur = async (e) => {
    e.preventDefault();
    if (code.length !== 6) return;
    setBezig(true);
    setFout('');
    try {
      const app = await gekoppeldeApp();
      // Geen app meer (losgekoppeld door de beheerder): de poort kijkt opnieuw wat nodig is.
      if (!app) { onHersteld(); return; }
      await bevestigCode(app.id, code);
      onKlaar();
    } catch (err) {
      setFout(tweestapsFoutMelding(err));
      setCode('');
      setBezig(false);
    }
  };

  const herstel = async (e) => {
    e.preventDefault();
    setBezig(true);
    setFout('');
    try {
      await gebruikHerstelcode(herstelcode);
      onHersteld();
    } catch (err) {
      setFout(err?.message || 'Er ging iets mis. Probeer het opnieuw.');
      setBezig(false);
    }
  };

  const wissel = (naar) => { setModus(naar); setFout(''); };

  if (modus === 'herstel') {
    return (
      <form onSubmit={herstel}>
        <p className="ts-uitleg">
          Vul één van je herstelcodes in. Je oude telefoon wordt dan losgekoppeld en je koppelt meteen een nieuwe.
          Geen herstelcodes? Vraag je schoolbeheerder om je tweede stap te resetten.
        </p>
        {fout && <div className="ts-fout" role="alert">{fout}</div>}
        <div className="ts-veld">
          <label htmlFor="ts-herstelcode">Herstelcode</label>
          <input
            ref={invoer}
            id="ts-herstelcode"
            className="ts-invoer"
            autoComplete="off"
            autoCapitalize="characters"
            spellCheck={false}
            placeholder="ABCD-EFGH-JKLM"
            value={herstelcode}
            onChange={(e) => setHerstelcode(e.target.value.slice(0, 20))}
            disabled={bezig}
          />
        </div>
        <button type="submit" className="ts-knop" disabled={bezig || herstelcode.replace(/[^a-z0-9]/gi, '').length !== 12}>
          {bezig ? 'Bezig…' : 'Herstelcode gebruiken'}
        </button>
        <button type="button" className="ts-link" onClick={() => wissel('code')} disabled={bezig}>Terug naar de code uit de app</button>
      </form>
    );
  }

  return (
    <form onSubmit={verstuur}>
      {fout && <div className="ts-fout" role="alert">{fout}</div>}
      <div className="ts-veld">
        <label htmlFor="ts-code">Code uit de app</label>
        <input
          ref={invoer}
          id="ts-code"
          className="ts-invoer ts-invoer-code"
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="000000"
          value={code}
          onChange={(e) => setCode(schoonCode(e.target.value))}
          disabled={bezig}
        />
      </div>
      <button type="submit" className="ts-knop" disabled={bezig || code.length !== 6}>
        {bezig ? 'Bezig…' : 'Inloggen'}
      </button>
      <button type="button" className="ts-link" onClick={() => wissel('herstel')} disabled={bezig}>Telefoon kwijt?</button>
    </form>
  );
}

export default TweestapsCode;
